const badges = {
	"brand new": "brand-new",
	"pre Order": "pre-order",
	"low stock": "low-stock",
	"out of stock": "no-stock",
	"top pick": "top-pick",
	"currently viewing": "currently-viewing",
	"one-time offer": "one-time-offer",
	"today only": "today-only",
	"for today only": "for-today-only",
	"double device deal": "device-deal",
	"limited offer": "limited_offer",
	"exclusive to online": "exclusive-to-online",
	"red hot dealz": "read-hot-dealz",
	"red hot deal": "red-hot-deal",
	"buy one get one free": "buy-one-get-one-free",
};

export default badges;
